module.exports = __webpack_public_path__ + "static/media/IMG_1317.af7b140c.jpg";